import { SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { useGetReleaseNotes } from '@/lib/contentful';
import { ReleaseNote } from './release-note';
import { ReleaseNoteErrorBoundary } from './release-note-error-boundary';

export function ReleaseNotesSheetContent() {
  const { data: releaseNotes } = useGetReleaseNotes();

  return (
    <>
      <SheetHeader className='flex flex-row items-center justify-between border-b pb-4'>
        <SheetTitle className='flex w-full items-center space-x-2'>
          <div className='mr-auto'>Release notes</div>
        </SheetTitle>
      </SheetHeader>

      <div className='flex h-full flex-col gap-6 overflow-y-auto pt-4'>
        {releaseNotes
          ?.sort((a, b) => b.date.getTime() - a.date.getTime())
          .map((note) => (
            <ReleaseNoteErrorBoundary key={note.id} noteId={note.id}>
              <ReleaseNote note={note} />
            </ReleaseNoteErrorBoundary>
          ))}
      </div>
    </>
  );
}
